/** WebSocket message.type values handled by the notification orchestrator. */
export const WEBSOCKET_EVENT_TYPES = {
  EXPORT_COMPLETE: "export-complete",
  ONBOARDING_POTENTIAL_CASES_COMPLETED: "onboarding-potential-cases-completed",
  BILLING_SUBSCRIPTION_ENDED: "billing-subscription-ended",
} as const;

export type WebSocketEventType =
  (typeof WEBSOCKET_EVENT_TYPES)[keyof typeof WEBSOCKET_EVENT_TYPES];

/** WS events that render in the bell — lockout is handled separately. */
export type BellNotificationEventType = Exclude<
  WebSocketEventType,
  typeof WEBSOCKET_EVENT_TYPES.BILLING_SUBSCRIPTION_ENDED
>;

/** Sub-variants for {@link WEBSOCKET_EVENT_TYPES.EXPORT_COMPLETE}. */
export const EXPORT_REPORT_TYPES = {
  FILED_CLAIMS: "filed_claims_report",
  UNFILED_CLAIMS: "unfiled_claims_report",
  REIMBURSEMENT: "reimbursement_report",
  INBOUND_OUTBOUND: "inbound_outbound_claims_report",
} as const;

export type ExportReportType =
  (typeof EXPORT_REPORT_TYPES)[keyof typeof EXPORT_REPORT_TYPES];

/** Route segments used when navigating from export-complete notifications. */
export const EXPORT_REPORT_ROUTES: Record<ExportReportType, string> = {
  [EXPORT_REPORT_TYPES.FILED_CLAIMS]: "report/cases/export-history",
  [EXPORT_REPORT_TYPES.UNFILED_CLAIMS]: "report/claims/export-history",
  [EXPORT_REPORT_TYPES.REIMBURSEMENT]: "report/reimbursements/export-history",
  [EXPORT_REPORT_TYPES.INBOUND_OUTBOUND]:
    "report/inbound-outbound/export-history",
};

/** Navigation target for onboarding potential-cases-completed notifications. */
export const ONBOARDING_CANDIDATE_CLAIMS_FOUND_ROUTE =
  "/initial-setup/candidate-claims-found";

export const ONBOARDING_CANDIDATE_CLAIMS_FOUND_QUERY_PARAMS = {
  CLAIM_FOUND: "claimFound",
  STORE_ID: "storeId",
} as const;
